var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService, prepareParams, } from "./baseService";
class DWOService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "dwo";
    }
    getAllDWOEmployees(options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const params = prepareParams(options);
            const { data } = yield this.api.get(`/${this.controllerName}/employees/workshift`, {
                params,
            });
            return data;
        });
    }
    getDWOCrewDetails(dwoId, jobId, dwoJobId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const params = prepareParams(options);
            if (jobId != null)
                params.jobId = jobId === null || jobId === void 0 ? void 0 : jobId.toString();
            if (dwoJobId != null)
                params.dwoJobId = dwoJobId.toString();
            const { data } = yield this.api.get(`/${this.controllerName}/${dwoId}/crew`, { params });
            return data;
        });
    }
    getDWOByForemanIdAndDate(foremanId, date) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}/foreman/${foremanId}/date/${date}`);
            return data;
        });
    }
    updateDWOForTimeOff(dwoId, dwoJobIds) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`/${this.controllerName}/${dwoId}/timeOff`, dwoJobIds);
            return data;
        });
    }
    saveMassiveDwo(dwoForeman) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`/${this.controllerName}/save`, dwoForeman);
            return data;
        });
    }
    getDwoSummaryData(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            if (options === null || options === void 0 ? void 0 : options.foremanId) {
                params.foremanId = options.foremanId;
            }
            if (options === null || options === void 0 ? void 0 : options.startDate) {
                params.startDate = options.startDate;
            }
            if (options === null || options === void 0 ? void 0 : options.endDate) {
                params.endDate = options.endDate;
            }
            const { data } = yield this.api.get(`/${this.controllerName}/summary`, { params });
            return data;
        });
    }
    saveAppState(date, foremanId, appStateBackup) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`/${this.controllerName}/appState`, { date, foremanId, appStateBackup });
            return data;
        });
    }
    getAppBackup(options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const params = prepareParams(options);
            const { data } = yield this.api.get(`/${this.controllerName}/appState`, { params });
            return data;
        });
    }
}
export const dwoService = new DWOService();
//# sourceMappingURL=dwoService.js.map